import React from "react";

function BS4_Editor() {
  return (
    <div>
      <h1>BS4_Editor Component</h1>
      <p>This is the BS4_Editor tutorial page content.</p>
    </div>
  );
}

export default BS4_Editor;
